// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__JWko6","label":"Labeled_label__3exiA","divider":"Labeled_divider__14QRx"};